import { render, staticRenderFns } from "./hqStuHealthKnowledgeTypeEdit.vue?vue&type=template&id=2b6e6f53&scoped=true"
import script from "./hqStuHealthKnowledgeTypeEdit.vue?vue&type=script&lang=js"
export * from "./hqStuHealthKnowledgeTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6e6f53",
  null
  
)

export default component.exports